/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import KeyWatcherEvent = alm.browser.KeyWatcherEvent;
	import KeyCode = alm.browser.KeyCode;

	export class Controller extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super(jQuery('#controller'));

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view:JQuery = this.getView();

			this.terrainTypeButton = new PushButton(view.find('.terrain-type'));
			this.terrainTypeButton.addEventListener('click', this.terrainTypeButtonClickHandler);

			this.currentLocationButton = new PushButton(view.find('.current-location'));
			this.currentLocationButton.addEventListener('click', this.currentLocationButtonClickHandler);

			this.speedButton = new SpeedButton(view.find('.speed-button'));
			this.speedButton.addEventListener(ControllerSpeedEvent.CHANGE, this.speedButtonClickHandler);

			this.playButton = new PlayButton(view.find('.play-button'));
			this.playButton.addEventListener(ControllerPlayPauseEvent.CHANGE, this.playButtonClickHandler);

			this.seekBar = new SeekBar(view.find('.seek-bar'));
			this.seekBar.addEventListener(ControllerSeekBarEvent.SEEK, this.seekBarSeekHandler);
			this.seekBar.addEventListener(ControllerSeekBarEvent.DRAG_START, this.seekBarDragStartHandler);
			this.seekBar.addEventListener(ControllerSeekBarEvent.DRAG_END, this.seekBarDragEndHandler);

			this.progressManager = ProgressManager.getInstance();
			this.progressManager.addEventListener(ProgressManagerPlayEvent.CHANGE, this.progressManagerPlayHandler);
			this.progressManager.addEventListener(ProgressManagerSeekEvent.SEEK, this.progressManagerSeekHandler);
			this.progressManager.addEventListener(ProgressManagerProgressEvent.PROGRESS, this.progressManagerProgressHandler);

			const threeManager = ThreeManager.getInstance();
			threeManager.addEventListener(CameraTrackingEvent.CHANGE, this.threeManagerCameraTrackingHandler);
			this.currentLocationButton.setIsEnabled(!threeManager.getIsTracking());

			// for debug
			/*
			KeyWatcher.addEventListener(KeyWatcherEvent.KEY_UP, this.keyWatcherKeyUpHandler);
			KeyWatcher.start();
			const w:JQuery<Window> = jQuery(window);
			w.on('mousemove', this.mouseMoveHandler);
			*/

			return view;
		}

		protected implReady():void {
			this.terrainTypeButton.ready();
			this.currentLocationButton.ready();
			this.speedButton.ready();

			this.playButton.ready();
			this.playButton.setState(this.progressManager.getIsPlaying());

			this.seekBar.ready();
			this.seekBar.setState(this.progressManager.getCurrentRatio());
		}

		protected implFinalize():void {
			this.terrainTypeButton.finalize();
			this.currentLocationButton.finalize();
			this.speedButton.finalize();
			this.playButton.finalize();
			this.seekBar.finalize();
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Serial(
				new cmd.Func(():void => {
					view.css('display', 'block');

					this.terrainTypeButton.show(useTransition);
					this.currentLocationButton.show(useTransition);
					this.speedButton.show(useTransition);
					this.playButton.show(useTransition);
					this.seekBar.show(useTransition);
				})
			);
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Serial(
				new cmd.Func(():void => {
					view.css('display', 'none');

					this.terrainTypeButton.hide(useTransition);
					this.currentLocationButton.hide(useTransition);
					this.speedButton.hide(useTransition);
					this.playButton.hide(useTransition);
					this.seekBar.hide(useTransition);
				})
			);
		}





		public setSpeedState(state:number):void {
			this.speedButton.setState(state);
		}





		private terrainTypeButtonClickHandler = (event:alm.event.Event):void => {
			this.dispatchEvent(new ControllerTerrainTypeEvent(ControllerTerrainTypeEvent.CHANGE, this));
		};

		private currentLocationButtonClickHandler = (event:alm.event.Event):void => {
			this.dispatchEvent(new ControllerLocationEvent(ControllerLocationEvent.CURRENT, this));
		};

		private speedButtonClickHandler = (event:ControllerSpeedEvent):void => {
			this.dispatchEvent(new ControllerSpeedEvent(ControllerSpeedEvent.CHANGE, this, event.getRequiredState()));
		};

		private playButtonClickHandler = (event:ControllerPlayPauseEvent):void => {
			this.dispatchEvent(new ControllerPlayPauseEvent(ControllerPlayPauseEvent.CHANGE, this, event.getIsPlayingRequired()));
		};

		private seekBarSeekHandler = (event:ControllerSeekBarEvent):void => {
			this.dispatchEvent(new ControllerSeekBarEvent(ControllerSeekBarEvent.SEEK, this, event.getRatio()));
		};

		private seekBarDragStartHandler = (event:ControllerSeekBarEvent):void => {
			this.dispatchEvent(new ControllerSeekBarEvent(ControllerSeekBarEvent.DRAG_START, this, event.getRatio()));
		};

		private seekBarDragEndHandler = (event:ControllerSeekBarEvent):void => {
			this.dispatchEvent(new ControllerSeekBarEvent(ControllerSeekBarEvent.DRAG_END, this, event.getRatio()));
		};





		private progressManagerPlayHandler = (event:ProgressManagerPlayEvent):void => {
			if (this.seekBar.getIsDragging()) return;
			this.playButton.setState(event.getIsPlaying());
		};

		private progressManagerSeekHandler = (event:ProgressManagerSeekEvent):void => {
			this.seekBar.setState(this.progressManager.getCurrentRatio());
		};

		private progressManagerProgressHandler = (event:ProgressManagerProgressEvent):void => {
			this.seekBar.setState(this.progressManager.getCurrentRatio());
		};





		private threeManagerCameraTrackingHandler = (event:CameraTrackingEvent):void => {
			this.currentLocationButton.setIsEnabled(!event.getIsTracking());
		};





		private keyWatcherKeyUpHandler = (event:KeyWatcherEvent):void => {
			switch (event.keyCode) {
				case KeyCode.Key1:
					this.dispatchEvent(new ControllerTerrainTypeEvent(ControllerTerrainTypeEvent.CHANGE, this));
					break;

				case KeyCode.P:
					this.dispatchEvent(new ControllerPlayPauseEvent(ControllerPlayPauseEvent.CHANGE, this, !this.progressManager.getIsPlaying()));
					break;
			}
		};

		private mouseMoveHandler = (event:JQuery.MouseMoveEvent):void => {
			const ratio:number = event.clientX / window.innerWidth;
			this.dispatchEvent(new ProgressManagerSeekEvent(ProgressManagerSeekEvent.SEEK, this, ratio));
		};





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private progressManager:ProgressManager;

		private terrainTypeButton:PushButton;
		private currentLocationButton:PushButton;
		private speedButton:SpeedButton;
		private playButton:PlayButton;
		private seekBar:SeekBar;
	}
}
